import { getConfiguration } from './getConfiguration';
/**
 * Returns the Styled Component styles variant based on the name.
 */
export const getVariantStyles = (name) => getConfiguration(name).styles;
//# sourceMappingURL=getVariantStyles.js.map